import React, { useEffect, useState } from 'react'
import RouteContainer from '../../../common/styles/RouteContainer'
import RouteTitle from '../../../common/RouteTitle/RouteTitle'
import booksitoutIcon from '../../../config/BooksitoutIcon'
import RouteTitleConfig from '../../../config/RouteTitleConfig'
import RowSpacer from '../../../common/styles/RowSpacer'
import CardBodyContentContainer from '../../../common/styles/CardBodyContentContainer'
import { Card, Form } from 'react-bootstrap'
import useBookSearchSettings from '../../search/bookSource/hooks/useBookSearchSettings'
import { BooksitoutServer } from '../../../config/BooksitoutServer'
import toast from 'react-hot-toast'
import useLoginStore from '../../login/useLoginStore'

const SettingsBookShelfRoute = () => {
	const isLogged = useLoginStore(state => state.isLoggedIn())
	useEffect(() => {
		if (!isLogged) {
			window.location.href = '/login'
		}
	}, [isLogged])

	const [settings, refresh] = useBookSearchSettings()

	const [enabled, setEnabled] = useState(true)
	const [addMemo, setAddMemo] = useState(true)
	useEffect(() => {
		if (settings != null) {
			setEnabled(settings.isReadingSourceEnabled)
			setAddMemo(settings.isReadingSourceMemoEnabled)
		}
	}, [settings])

	const updateSetting = (updates: { isReadingSourceEnabled?: boolean; isReadingSourceMemoEnabled?: boolean }) => {
		if (settings == null) return
		BooksitoutServer.put('/v1/book/search/settings', {
			librarySearchMethod: settings.librarySearchMethod,
			regionIds: settings.regionDetails.map(r => r.id),
			libraryIds: settings.libraries.map(l => l.id),
			...updates,
		}).then(() => refresh())
	}

	const toggleEnabled = () => {
		const newValue = !enabled
		setEnabled(newValue)
		updateSetting({ isReadingSourceEnabled: newValue })
		toast.success(newValue ? '책 구할 곳을 사용하도록 설정했어요.' : '책 구할 곳을 사용하지 않도록 설정했어요.')
	}

	const toggleAddMemo = () => {
		const newValue = !addMemo
		setAddMemo(newValue)
		updateSetting({ isReadingSourceMemoEnabled: newValue })
		toast.success(newValue ? '메모를 입력하도록 설정했어요.' : '메모를 건너뛰도록 설정했어요.')
	}

	return (
		<RouteContainer>
			<RouteTitle icon={<booksitoutIcon.settings />} title={'내 서재 설정'} currentKey={'BOOK_SHELF'} buttons={RouteTitleConfig.Settings} />
			<RowSpacer />

			<Card>
				<CardBodyContentContainer>
					<div className="row justify-content-center m-0" style={{ padding: '12px 0' }}>
						<h4 className="mb-3">책 구할 곳</h4>
						<div style={{ paddingLeft: '32px', display: 'flex', flexDirection: 'column', gap: '8px' }}>
							<Form.Check
								type="switch"
								label="기능 사용하기"
								checked={enabled}
								onChange={toggleEnabled}
							/>
							<Form.Check
								type="switch"
								label="메모 추가하기"
								checked={addMemo}
								onChange={toggleAddMemo}
							/>
						</div>
					</div>
				</CardBodyContentContainer>
			</Card>
		</RouteContainer>
	)
}

export default SettingsBookShelfRoute
